const steps = [
  {
    n: "01",
    title: "Vérification",
    desc: "Nous analysons votre situation pour identifier vos droits potentiels aux subsides cantonaux.",
  },
  {
    n: "02",
    title: "Simulation",
    desc: "Estimation indicative du subside annuel auquel vous pourriez prétendre.",
  },
  {
    n: "03",
    title: "Optimisation",
    desc: "Comparatif neutre des caisses LAMal et compléments LCA pour réduire vos primes.",
  },
  {
    n: "04",
    title: "Accompagnement",
    desc: "Préparation du dossier de demande et suivi administratif personnalisé.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="comment-ca-marche"
      data-testid="how-it-works-section"
      className="py-24 md:py-32 border-t border-slate-200 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl">
          <div className="text-xs tracking-[0.2em] uppercase font-bold text-spi-red mb-4">
            Notre méthode
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-spi-blue font-bold">
            Un accompagnement clair, transparent et 100 % indépendant.
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {steps.map((s, i) => (
            <div key={s.n} className={`fade-up delay-${i + 1}`}>
              <div className="font-display text-6xl text-slate-200 font-light leading-none">
                {s.n}
              </div>
              <div className="mt-4 h-px bg-spi-red w-12" />
              <h3 className="mt-6 font-display text-xl text-spi-blue font-semibold">{s.title}</h3>
              <p className="mt-3 text-slate-600 leading-relaxed text-sm">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
